// @flow
import * as React from 'react';

// Components
import AppRouter from './AppRouter';
import { withEasterEgg } from 'components/common/decorators/easterEgg/EasterEgg';
import AppMask from './AppMask';

const App = () => {
  return [<AppRouter key="router" />, <AppMask key="mask" />];
};

export default withEasterEgg(App);



// WEBPACK FOOTER //
// ./src/components/selfCheckIn/App.js